import { archivePlanThunk } from './archivePlanThunk';
export default archivePlanThunk;
